import React, { useState, useEffect } from "react"
import { Formik, Form, Field, ErrorMessage } from "formik"
import * as Yup from "yup"
import { Col, Container, Row } from "reactstrap"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import {
  Fn_AddEditData,
  Fn_DisplayData,
  Fn_FillListData,
} from "../../store/Functions"
import { API_WEB_URLS } from "../../constants/constAPI"
import Breadcrumbs from "../../components/Common/Breadcrumb"

function AddEdit_PropertyDeal() {
  const API_URL_SAVE = `${API_WEB_URLS.PropertyDeal}/0/token`
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/PropertyDealEdit/Id`
  const API_URL = API_WEB_URLS.MASTER + "/0/token/PropertyDeal"
  const [state, setState] = useState({
    id: 0,
    FillArray: [],
    formData: {},
    OtherDataScore: [],
    isProgress: true,
  })
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()

  const dealDurations = [
    { Id: 1, Name: "Weekly" },
    { Id: 2, Name: "Monthly" },
    { Id: 3, Name: "Yearly" },
    // Add more options as needed
  ]

  useEffect(() => {
    const Id = (location.state && location.state.Id) || 0
    Fn_FillListData(dispatch, setState, "FillArray", API_URL + "/Id/0")
    if (Id > 0) {
      setState(prevState => ({
        ...prevState,
        id: Id,
      }))
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT)
    }
  }, [location.state, dispatch])

  const validationSchema = Yup.object({
    Name: Yup.string().required("Name is required"),
    Duration: Yup.number()
      .required("Duration is required")
      .positive()
      .integer(),
    ReturnPercentage: Yup.number()
      .required("Return Percentage is required")
      .positive(),
    DealDate: Yup.date().required("Deal Date is required"),
    PropertyAddress: Yup.string().required("Property Address is required"),
    DealAmount: Yup.number().required("Deal Amount is required").positive(),
    F_DealDurationMaster: Yup.number().required("Deal Duration is required"),
  })

  const handleSubmit = values => {
    const obj = JSON.parse(localStorage.getItem("YesBank"))
    const formData = new FormData()
    formData.append("PropertyTitle", values.Name)
    formData.append("UserId", obj.Id)
    formData.append("DealReturn", values.Duration)
    formData.append("ReturnPercentage", values.ReturnPercentage)
    formData.append("DealDate", values.DealDate)
    formData.append("PropertyAddress", values.PropertyAddress)
    formData.append("DealAmount", values.DealAmount)
    formData.append("F_DealDurationMaster", values.F_DealDurationMaster)

    Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData } },
      API_URL_SAVE,
      true,
      "memberid",
      navigate,
      "/DepartmentMaster"
    )
  }

  return (
    <div className="page-content">
      <Container boxed={true}>
        <Breadcrumbs title="Department Master" breadcrumbItem="Masters" />
        <Formik
          initialValues={state.formData}
          enableReinitialize={true}
          validationSchema={validationSchema}
          onSubmit={values => handleSubmit(values)}
        >
          <Form className="form-horizontal">
            <Row>
              <Col lg="6" className="mb-3">
                <label htmlFor="Name" className="form-label">
                  Name
                </label>
                <Field className="form-control" type="text" name="Name" />
                <ErrorMessage
                  name="Name"
                  component="div"
                  className="text-danger"
                />
              </Col>
              <Col lg="6" className="mb-3">
                <label htmlFor="DealAmount" className="form-label">
                  Deal Amount
                </label>
                <Field
                  className="form-control"
                  type="number"
                  name="DealAmount"
                />
                <ErrorMessage
                  name="DealAmount"
                  component="div"
                  className="text-danger"
                />
              </Col>
              <Col lg="6" className="mb-3">
                <label htmlFor="F_DealDurationMaster" className="form-label">
                  Deal Duration
                </label>
                <Field
                  as="select"
                  className="form-control"
                  name="F_DealDurationMaster"
                >
                  <option value="">Select Duration</option>
                  {dealDurations.map(duration => (
                    <option key={duration.Id} value={duration.Id}>
                      {duration.Name}
                    </option>
                  ))}
                </Field>
                <ErrorMessage
                  name="F_DealDurationMaster"
                  component="div"
                  className="text-danger"
                />
              </Col>
              <Col lg="6" className="mb-3">
                <label htmlFor="Duration" className="form-label">
                  Duration
                </label>
                <Field className="form-control" type="number" name="Duration" />
                <ErrorMessage
                  name="Duration"
                  component="div"
                  className="text-danger"
                />
              </Col>
              <Col lg="6" className="mb-3">
                <label htmlFor="ReturnPercentage" className="form-label">
                  Return Percentage
                </label>
                <Field
                  className="form-control"
                  type="number"
                  name="ReturnPercentage"
                />
                <ErrorMessage
                  name="ReturnPercentage"
                  component="div"
                  className="text-danger"
                />
              </Col>
              <Col lg="6" className="mb-3">
                <label htmlFor="DealDate" className="form-label">
                  Deal Date
                </label>
                <Field className="form-control" type="date" name="DealDate" />
                <ErrorMessage
                  name="DealDate"
                  component="div"
                  className="text-danger"
                />
              </Col>
              <Col lg="6" className="mb-3">
                <label htmlFor="PropertyAddress" className="form-label">
                  Property Address
                </label>
                <Field
                  className="form-control"
                  type="text"
                  name="PropertyAddress"
                />
                <ErrorMessage
                  name="PropertyAddress"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </Row>

            <button type="submit" className="btn btn-primary btn-block">
              Submit
            </button>
          </Form>
        </Formik>
      </Container>
    </div>
  )
}

export default AddEdit_PropertyDeal
